import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "breadcrumb-item" }
const _hoisted_11 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_12 = {
  id: "main",
  class: ""
}
const _hoisted_13 = { class: "container px-xs-0 pt-2 pt-sm-2 pt-md-0" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row mx-0 beratung" }
const _hoisted_17 = { class: "col-12 col-headline bg-white" }
const _hoisted_18 = { class: "col-12 col-md-5 col-lg-3 mb-3 mt-3 mt-md-0 bg-white beratung-sidebar" }
const _hoisted_19 = { class: "beratung-sidebar-block" }
const _hoisted_20 = { class: "mb-2 block-head d-flex align-items-center" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "block-text" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { class: "beratung-sidebar-block" }
const _hoisted_29 = { class: "beratung-sidebar-block-kontakt" }
const _hoisted_30 = {
  key: 0,
  class: "block-head d-flex align-items-center"
}
const _hoisted_31 = ["href", "title"]
const _hoisted_32 = {
  key: 1,
  class: "block-head d-flex align-items-center"
}
const _hoisted_33 = ["href", "title"]
const _hoisted_34 = {
  key: 2,
  class: "block-head d-flex align-items-center"
}
const _hoisted_35 = ["href", "title"]
const _hoisted_36 = {
  key: 3,
  class: "block-head d-flex align-items-center"
}
const _hoisted_37 = ["href", "title"]
const _hoisted_38 = { class: "col-12 col-md-7 col-lg-9 mb-3 bg-white beratung-content" }
const _hoisted_39 = {
  key: 0,
  lang: "de",
  class: "beratung-content-block"
}
const _hoisted_40 = {
  key: 1,
  lang: "de",
  class: "beratung-content-block-einrichtungen"
}
const _hoisted_41 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_loading_container, {
    state: _ctx.state,
    i18nErrorMessage: "views.legalEntities.errorMessage"
  }, {
    default: _withCtx(() => [
      (!_ctx.notFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("nav", _hoisted_6, [
                      _createElementVNode("ol", _hoisted_7, [
                        _createElementVNode("li", _hoisted_8, [
                          _createElementVNode("a", { href: _ctx.langMain }, _toDisplayString(_ctx.$t('detailviews.home')), 9, _hoisted_9)
                        ]),
                        _createElementVNode("li", _hoisted_10, [
                          _createVNode(_component_router_link, { to: '/' }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('detailviews.counselingCenters')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.$t('detailviews.legalEntities')) + ": " + _toDisplayString(_ctx.legalEntity.name), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("main", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.routerbacklinkCC === 'y')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          role: "button",
                          class: "btn btn-link btn-back text-black",
                          to: {
            name: 'counseling-center',
            params: { ccid: _ctx.routerccid,  backlink: _ctx.routerbacklink, backlinkCC: 'y', backUrlHistory: _ctx.backUrlHistory}
          },
                          title: _ctx.$t('detailviews.backLinkCC')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('detailviews.backLinkCC')), 1)
                          ]),
                          _: 1
                        }, 8, ["to", "title"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.legalEntity.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[0] || (_cache[0] = _createElementVNode("div", {
                          class: "icon svg-adresse",
                          "aria-hidden": "true"
                        }, null, -1)),
                        _createElementVNode("h2", _hoisted_21, _toDisplayString(_ctx.$t('detailviews.address')) + ":", 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", null, [
                          (_ctx.legalEntity.address.streetName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.legalEntity.address.streetName), 1))
                            : _createCommentVNode("", true),
                          _cache[2] || (_cache[2] = _createTextVNode()),
                          (_ctx.legalEntity.address.houseNumber)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, " " + _toDisplayString(_ctx.legalEntity.address.houseNumber), 1))
                            : _createCommentVNode("", true),
                          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                          (_ctx.legalEntity.address.addressSupplement)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createTextVNode(_toDisplayString(_ctx.legalEntity.address.addressSupplement) + " ", 1),
                                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.legalEntity.address.zipCode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.legalEntity.address.zipCode), 1))
                            : _createCommentVNode("", true),
                          _cache[4] || (_cache[4] = _createTextVNode()),
                          (_ctx.legalEntity.address.city)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, " " + _toDisplayString(_ctx.legalEntity.address.city), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        (_ctx.legalEntity.phone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _cache[5] || (_cache[5] = _createElementVNode("div", {
                                class: "icon svg-tel",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                href: _ctx.formattedPhoneHref(_ctx.legalEntity.phone),
                                rel: "noopener",
                                title: _ctx.$t('detailviews.telLinkTitle'),
                                class: "h3link"
                              }, _toDisplayString(_ctx.legalEntity.phone), 9, _hoisted_31)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.legalEntity.phone2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _cache[6] || (_cache[6] = _createElementVNode("div", {
                                class: "icon svg-tel",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                href: _ctx.formattedPhoneHref(_ctx.legalEntity.phone2),
                                rel: "noopener",
                                title: _ctx.$t('detailviews.telLinkTitle'),
                                class: "h3link"
                              }, _toDisplayString(_ctx.legalEntity.phone2), 9, _hoisted_33)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.legalEntity.email)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[7] || (_cache[7] = _createElementVNode("div", {
                                class: "icon svg-email",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                rel: "noopener",
                                href: _ctx.formattedEmailHref(_ctx.legalEntity.email),
                                title: _ctx.$t('detailviews.mailLinkTitle'),
                                class: "h3link"
                              }, _toDisplayString(_ctx.$t('detailviews.sendMail')), 9, _hoisted_35)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.legalEntity.homepage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _cache[8] || (_cache[8] = _createElementVNode("div", {
                                class: "icon svg-www",
                                "aria-hidden": "true"
                              }, null, -1)),
                              _createElementVNode("a", {
                                href: _ctx.formattedUrlHref(_ctx.legalEntity.homepage),
                                title: _ctx.$t('detailviews.urlLinkTitle'),
                                class: "h3link extern",
                                rel: "noopener nofollow",
                                target: "_blank"
                              }, _toDisplayString(_ctx.$t('detailviews.goToUrl')), 9, _hoisted_37)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.legalEntity.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('detailviews.aboutUs')), 1),
                          _withDirectives(_createElementVNode("div", null, null, 512), [
                            [_directive_dompurify_html, _ctx.legalEntity.description]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cCenterListe.content)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('detailviews.centers')), 1),
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedCCentersOther(), (center, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _createVNode(_component_router_link, {
                                  to: '/counseling-center/'+center.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(center.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createTextVNode(", " + _toDisplayString(center.address.zipCode) + " " + _toDisplayString(center.address.city), 1)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedCCentersCourt(), (center, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _createVNode(_component_router_link, {
                                  to: '/counseling-center/'+center.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(center.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createTextVNode(", " + _toDisplayString(center.address.zipCode) + " " + _toDisplayString(center.address.city), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[9] || (_cache[9] = [
            _createElementVNode("main", {
              id: "main",
              class: ""
            }, [
              _createElementVNode("div", { class: "container px-xs-0" }, [
                _createElementVNode("div", { class: "row mx-0 beratung" }, [
                  _createElementVNode("div", { class: "col-12 col-headline bg-white border-0" }, [
                    _createElementVNode("h2", null, "$t('detailviews.leNotFound') }}")
                  ])
                ])
              ])
            ], -1)
          ])))
    ]),
    _: 1
  }, 8, ["state"]))
}